import styled from 'styled-components';

interface ItemProps {
  readonly status?: string;
  readonly display?: string;
  readonly inputStyle?: string;
}

export const PrincipalContainer = styled.div<ItemProps>`
  left: 0;
  z-index: 1;
  width: 100%;
  display: flex;
  margin-top: 10px;
  position: absolute;
  justify-content: center;
  display: ${props => props.status === 'error' ? 'flex' : 'none'};
`;

export const TextboxWarning = styled.span<ItemProps>`  
  padding: 16px;
  display: flex;
  max-width: 371px;
  min-height: 70px;
  position: relative;
  border-radius: 4px;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  width: calc(100% - 30px);
  background: ${props => props.inputStyle === 'error' ? '#FFE5E5' : '#FFF5E6'};
  border: ${props => props.inputStyle === 'error' ? 'none' : '1px solid #FFBF56'};

  &:after, 
  &:before { 
    content: ''; 
    width: 0; 
    height: 0; 
    left: 100%; 
    display: block; 
    position: absolute; 
    border-style: solid; 
  } 

  &:before { 
    top: -18.5px; 
    border-width: 9px; 
    left: calc(50% - 18px/2);
    border-color: transparent transparent ${props => props.inputStyle === 'error' ? 'transparent' : '#FFBF56'} transparent; 
  }

  &:after { 
    top: -17px; 
    border-width: 9px; 
    left: calc(50% - 18px/2);
    border-color: transparent transparent ${props => props.inputStyle === 'error' ? '#FFE5E5' : '#FFF5E6'} transparent; 
  }   
`;

export const Title = styled.span<ItemProps>`
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;
  font-style: normal;
  text-align: center;
  font-family: 'Proxima Nova';
  color: ${props => props.inputStyle === 'error' ? '#CC0000' : '#2B323B'};
`;

export const Message = styled.span<ItemProps>`
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
  text-align: center;
  font-style: normal;
  font-family: 'Proxima Nova';
  color: ${props => props.inputStyle === 'error' ? '#CC0000' : '#38424D'};
`;

